import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["shapeConfigs", "entityGroups", "id"];
import React from 'react';
import PropTypes from 'prop-types';
import isNumber from 'lodash.isnumber';
import { useQuery } from '@apollo/client';
import { getAction } from '@blaze-cms/react-page-builder';
import { useGetImages } from './hooks';
import { buildQuery, getImageIds, getCenterCoordinates, buildMapShapes } from './helpers';
import GoogleMaps from './GoogleMaps';
import GoogleMapsHtml from './GoogleMapsHtml';
const defaultQuery = getAction('getPublishedPages', 'id');
const GoogleMapsRender = _ref => {
  let {
      shapeConfigs,
      entityGroups,
      id
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const {
    defaultZoom
  } = otherProps;
  const {
    query
  } = buildQuery(shapeConfigs);
  const {
    data,
    loading,
    error
  } = useQuery(query || defaultQuery, {
    skip: !query
  });
  const mapShapes = buildMapShapes(shapeConfigs, data);
  const imageIds = getImageIds(mapShapes);
  const {
    data: {
      getFiles: imageData
    } = {},
    loading: imagesLoading,
    error: imagesError
  } = useGetImages(imageIds);
  if (loading || imagesLoading) return /*#__PURE__*/React.createElement(GoogleMapsHtml, null);
  if (error || imagesError) return null;
  const centerCoordinates = getCenterCoordinates(mapShapes, otherProps);
  const shouldDisplayMap = isNumber(defaultZoom) && !!centerCoordinates.length;
  if (!shouldDisplayMap) return null;
  return /*#__PURE__*/React.createElement(GoogleMaps, _extends({
    key: otherProps.slug,
    centerCoordinates: centerCoordinates,
    mapShapes: mapShapes,
    imageData: imageData
  }, otherProps));
};
GoogleMapsRender.propTypes = {
  entityGroups: PropTypes.array,
  id: PropTypes.string,
  shapeConfigs: PropTypes.array,
  centerLatitude: PropTypes.number,
  centerLongitude: PropTypes.number,
  defaultZoom: PropTypes.number
};
GoogleMapsRender.defaultProps = {
  entityGroups: [],
  shapeConfigs: [],
  id: '',
  centerLatitude: null,
  centerLongitude: null,
  defaultZoom: null
};
export default GoogleMapsRender;
//# sourceMappingURL=GoogleMapsRender.js.map